import React, { useEffect, useState } from "react";
import { FormSection } from "../../../components";

import * as s from './formPesquisa.module.css';

export default function FormPesquisaPorNumeroRebanhos({ handleConsulta }) {
  const [consulta, setConsulta] = useState("");
  const [depsOpen, setDepsOpen] = useState(true);

  const handleInput = (event) => {
    const { name, value } = event.target;
    setConsulta({ ...consulta, [name]: value });
  };

  useEffect(() => {
    handleConsulta(consulta);
    // eslint-disable-next-line
  }, [consulta]);

  return (
    <div className="main-content">
      <div
        className="container__title-content"
        onClick={() => setDepsOpen(!depsOpen)}
      >
        <FormSection
          title="Pesquisa por Número de Rebanhos / Filhos"
          borderBottomWidth={356}
        ></FormSection>
       
        {!depsOpen ? (
          <div className="blue-arrow blue-arrow-down" />
        ) : (
          <div className="blue-arrow blue-arrow-up" />
        )}
      </div>

      <div className={`global-input-container ${depsOpen ? "slide" : ""}`}>
        <HeaderColumnsInputs />
        <HeaderColumnsInputs />
        <HeaderColumnsInputs />

        <div className="col-3">
          <div className="input">
            <label>NF3P</label>
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nf3pMin"
              id="nf3pMin"
              value={consulta.nf3pMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nf3Max"
              id="nf3Max"
              value={consulta.nf3Max || ""}
              onChange={handleInput}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="input">
            <label>NN120</label>
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nn120Min"
              id="nn120Min"
              value={consulta.nn120Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nn120Max"
              id="nn120Max"
              value={consulta.nn120Max || ""}
              onChange={handleInput}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="input">
            <label>NR120</label>
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nr120Min"
              id="nr120Min"
              value={consulta.nr120Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nr120Max"
              id="nr120Max"
              value={consulta.nr120Max || ""}
              onChange={handleInput}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="input">
            <label>NFSTAY</label>
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nfstayMin"
              id="nfstayMin"
              value={consulta.nfstayMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nfstayMax"
              id="nfstayMax"
              value={consulta.nfstayMax || ""}
              onChange={handleInput}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="input">
            <label>NF120</label>
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nf120Min"
              id="nf120Min"
              value={consulta.nf120Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nf120Max"
              id="nf120Max"
              value={consulta.nf120Max || ""}
              onChange={handleInput}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="input">
            <label>NR450</label>
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nr450Min"
              id="nr450Min"
              value={consulta.nr450Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nr450Max"
              id="nr450Max"
              value={consulta.nr450Max || ""}
              onChange={handleInput}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="input">
            <label>NF210</label>
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nf210Min"
              id="nf210Min"
              value={consulta.nf210Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nf210Max"
              id="nf210Max"
              value={consulta.nf210Max || ""}
              onChange={handleInput}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="input">
            <label>NR210</label>
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nr210Min"
              id="nr210Min"
              value={consulta.nr210Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nr210Max"
              id="nr210Max"
              value={consulta.nr210Max || ""}
              onChange={handleInput}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="input">
            <label>NRUS</label>
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nrusMin"
              id="nrusMin"
              value={consulta.nrusMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nrusMax"
              id="nrusMax"
              value={consulta.nrusMax || ""}
              onChange={handleInput}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="input">
            <label>NF450</label>
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nf450Min"
              id="nf450Min"
              value={consulta.nf450Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nf450Max"
              id="nf450Max"
              value={consulta.nf450Max || ""}
              onChange={handleInput}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="input">
            <label>NFSAMS</label>
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nfsamsMin"
              id="nfsamsMin"
              value={consulta.nfsamsMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nfsamsMax"
              id="nfsamsMax"
              value={consulta.nfsamsMax || ""}
              onChange={handleInput}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="input">
            <label>NRN120</label>
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nrn120Min"
              id="nrn120Min"
              value={consulta.nrn120Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nrn120Max"
              id="nrn120Max"
              value={consulta.nrn120Max || ""}
              onChange={handleInput}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="input">
            <label>NFUS</label>
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nfusMin"
              id="nfusMin"
              value={consulta.nfusMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"              
              type="text"
              name="nfusMax"
              id="nfusMax"
              value={consulta.nfusMax || ""}
              onChange={handleInput}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

const HeaderColumnsInputs = () => {
  return (
    <div className={`col-3 ${ s.rowColumns }`}>
      <div style={{ width: 45 }}/>

      <div className={ s.columnLabel }>
        <span>Min</span>
      </div>

      <div className={ s.columnLabel }>
        <span>Max</span>
      </div>
    </div>
  );
};